<template>
  <sSelect
    :data-qa="dataQa"
    multiple
    :value.sync="valueMutable">
    <sOption
      v-for="itemElement in items"
      :key="`option-${itemElement.title}`"
      class="h11-links"
      :data-qa="`option-${itemElement.title}`"
      :label="itemElement.title"
      :value="itemElement.title"/>
  </sSelect>
</template>
<script>
import { criteriasMixin } from 'mixins'

export default {
  name: 'criteriaActivatorDictionary',
  mixins: [criteriasMixin],
  props: {
    value: {
      type: String
    },
    items: Array,
    dataQa: {
      type: String,
      default: 'select-dictionary-value'
    },
  },
  computed: {
    valueMutable: {
      get() {
        return this.$_parseListValue(this.value)
      },
      set(value) {
        if (!Array.isArray(value) || value.length === 0) {
          this.$emit('update:value', '')
        } else {
          this.$emit('update:value', value.join(','))
        }
      }
    }
  },
}
</script>
